/**
 * 上传模块类型定义（/api/v1/files/getAliUploadToken 返回）
 * @module types/upload
 */

// ============================================
// OSS 上传配置
// ============================================

/** OSS 上传配置 */
export interface OSSUploadConfig {
  /** Access ID */
  accessid: string
  /** 回调配置（Base64） */
  callback: string
  /** 上传目录 */
  dir: string
  /** 过期时间戳 */
  expire: number
  /** OSS Host */
  host: string
  /** 上传策略（Base64） */
  policy: string
  /** 签名 */
  signature: string
}

/** 上传凭证响应 */
export interface UploadTokenResponse {
  /** 响应码 */
  code: number
  /** 响应消息 */
  msg: string
  /** 响应数据 */
  data: {
    /** 过期时间（秒） */
    expires: number
    /** OSS 配置 */
    config: OSSUploadConfig
  }
}

// ============================================
// 上传参数
// ============================================

/** 上传参数 */
export interface UploadParams {
  /** 文件对象 */
  file: File
  /** 上传场景，默认 'image' */
  scene?: string
  /** Key 类型，默认 2 */
  keyType?: number
  /** 上传进度回调 */
  onProgress?: (progress: number) => void
}

/** 上传结果 */
export interface UploadResult {
  /** 文件 Key（相对路径） */
  key: string
  /** 完整 URL */
  url?: string
}

// ============================================
// 上传限制
// ============================================

/** 支持的文件类型 */
export type SupportedFileType = 'image/jpeg' | 'image/png' | 'image/webp'

/** 上传限制配置 */
export interface UploadLimits {
  /** 最大文件大小（字节） */
  maxSize: number
  /** 支持的文件类型 */
  allowedTypes: SupportedFileType[]
  /** 最小宽度（像素） */
  minWidth?: number
  /** 最大宽度（像素） */
  maxWidth?: number
  /** 最小高度（像素） */
  minHeight?: number
  /** 最大高度（像素） */
  maxHeight?: number
}

/** 默认上传限制 */
export const DEFAULT_UPLOAD_LIMITS: UploadLimits = {
  maxSize: 10 * 1024 * 1024, // 10MB
  allowedTypes: ['image/jpeg', 'image/png', 'image/webp'],
  minWidth: 512,
  maxWidth: 4096,
  minHeight: 512,
  maxHeight: 4096
}
